var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2979 25.4336H10.6816V30.1811H27.2979V25.4336Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.99 1.69727C16.5166 1.70294 14.0958 2.4111 12.0092 3.73929C9.92272 5.06747 8.25642 6.96103 7.20434 9.1995C6.15226 11.438 5.75769 13.9292 6.06657 16.3833C6.37545 18.8373 7.37507 21.1531 8.94905 23.061H29.031C30.605 21.1531 31.6046 18.8373 31.9135 16.3833C32.2223 13.9292 31.8278 11.438 30.7757 9.1995C29.7236 6.96103 28.0573 5.06747 25.9708 3.73929C23.8843 2.4111 21.4634 1.70294 18.99 1.69727Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.803 37.3022H20.1767C21.5448 37.3025 22.8709 36.8301 23.9307 35.9649C24.9905 35.0998 25.7188 33.8951 25.9924 32.5547H11.9873C12.2609 33.8951 12.9892 35.0998 14.049 35.9649C15.1088 36.8301 16.4349 37.3025 17.803 37.3022Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewDark);
export default __webpack_public_path__ + "static/media/reviewDark.18b2a6ba59d083d310dc7d7b0058efea.svg";
export { ForwardRef as ReactComponent };